module.exports = __webpack_public_path__ + "static/media/guinness.8295bf6f.svg";